import * as fabric from 'office-ui-fabric-react';
import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const CommandBarBasicExample: FC = () => {
    const { organizationInformationId } = useParams<'organizationInformationId'>();
    const navigate = useNavigate();

    const getItems = () => {
        return [
            {
                key: 'Organizacijos informacija',
                name: 'Organizacijos informacija',
                iconProps: {
                    iconName: 'Info'
                },
                onClick: () => `/administration/organization/${organizationInformationId}/information`,
                disabled: organizationInformationId === undefined
            },
            {
                key: 'Įrenginiai',
                name: 'Įrenginiai',
                iconProps: {
                    iconName: 'Devices4'
                },
                onClick: () => navigate(`/administration/organization/${organizationInformationId}/devices`),
                disabled: organizationInformationId === undefined
            },
            {
                key: 'Lokacijos',
                name: 'Lokacijos',
                iconProps: {
                    iconName: 'Location'
                },
                onClick: () => navigate(`/administration/organization/${organizationInformationId}/locations`),
                disabled: organizationInformationId === undefined
            },
            {
                key: 'Eilės',
                name: 'Eilės',
                iconProps: {
                    iconName: 'DOM'
                },
                onClick: () => navigate(`/administration/organization/${organizationInformationId}/queues`),
                disabled: organizationInformationId === undefined
            },
            {
                key: 'Paslaugos',
                name: 'Paslaugos',
                iconProps: {
                    iconName: 'BuildQueue'
                },
                onClick: () => navigate(`/administration/organization/${organizationInformationId}/services`),
                disabled: organizationInformationId === undefined
            },
            {
                key: 'Bendri nustatymai',
                name: 'Bendri nustatymai',
                iconProps: {
                    iconName: 'Settings'
                },
                onClick: () => navigate(`/administration/organization/${organizationInformationId}/generalSettings`),
                disabled: organizationInformationId === undefined
            },
            {
                disabled: true,
                key: 'Nustatymų vedlys',
                name: 'Nustatymų vedlys',
                iconProps: {
                    iconName: 'PublishCourse'
                },
                onClick: () => navigate(`/administration/organization/${organizationInformationId}/wizard`)
            }
        ];
    };
    return <fabric.CommandBar styles={{ root: { margin: '20px 0px', border: '1px solid rgba(136,136,136,0.3)' } }} items={getItems()} />;
};

export default CommandBarBasicExample;
